import { Step } from 'react-joyride';

export enum RankingIndexJoyrideTarget {
  FOLLOW_MEMBER = 'joyrideTargetFollowMember',
  TOP_MOST_RECENT_IDEAS = 'joyrideTargetTopMostRecentIdeas',
  RANKINGS_BY_CATEGORY = 'joyrideTargetRankingsByCategory'
}

export const rankingIndexJoyrideSteps: {
  followMember: Step;
  topMostRecentIdeas: Step;
  rankingsByCategory: Step;
} = {
  followMember: {
    title: 'Follow Top Ranked Members',
    target: `[data-joyride-target="${RankingIndexJoyrideTarget.FOLLOW_MEMBER}"]`,
    placement: 'auto',
    content:
      'Follow Top Ranked Members to build your SumZero network and stay up to date on their activity',
    disableBeacon: true,
    disableScrolling: true
  },
  topMostRecentIdeas: {
    title: 'Top and Most Recent Ideas',
    target: `[data-joyride-target="${RankingIndexJoyrideTarget.TOP_MOST_RECENT_IDEAS}"]`,
    placement: 'auto',
    content: 'View their top performing ideas and most recent submissions here.'
  },
  rankingsByCategory: {
    title: 'Rankings by Category',
    target: `[data-joyride-target="${RankingIndexJoyrideTarget.RANKINGS_BY_CATEGORY}"]`,
    placement: 'right-start',
    content: 'Click on a different category to view the Top Rank Members in that group.'
  }
};
